<template>
	<v-chip
		v-bind="$props"
		:color="color"
		:text-color="textColor"
		x-small
	>
		<slot />
	</v-chip>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: null
		},
		textColor: {
			type: String,
			default: null
		}
	}
}
</script>
